{
    "api_keys": {
        "label": "z.B. Production - meine Integration",
        "companies": "Firmen auswählen"
    },
    "work_email": "name@unternehmen.de",
    "billing_name": "z.B. Ihr Firmenname",
    "password": "Bitte geben Sie das Passwort ein",
    "confirmPassword": "Bitte geben Sie das Passwort erneut ein",
    "new_password": "Bitte geben Sie das neue Passwort ein.",
    "confirm_new_password": "Bitte geben Sie das neue Passwort erneut ein.",
    "comment": "Kommentar...",
    "request": {
        "item_name": "Artikel",
        "total_price": "0,00",
        "quantity": "0",
        "description": "Dies ist wichtig für unser nächstes Projekt.",
        "subscription_name": "Mein neues Abonnement",
        "subscription_price": "0,00",
        "link": "http://www.domain.de/",
        "date": "TT.MM.JJJJ",
        "date_format": {
            "month_year": "MM.JJJJ"
        },
        "reject": "Begründung der Ablehnung",
        "request_changes": "Welche Änderungen möchten Sie anfordern?",
        "invoiceNumber": "Rechnungsnummer",
        "mileage": {
            "select_a_vehicle": "Wählen Sie ein Fahrzeug",
            "distance": "Fahrtstrecke eingeben",
            "start_address": "Geben Sie die Startadresse ein",
            "destination_address": "Geben Sie die Zieladresse ein",
            "reason": "Geben Sie den Grund für die Reise ein",
            "additional_stop": "Geben Sie eine zusätzliche Haltestellenadresse ein",
            "additional_distance_reason": "Stau"
        },
        "hospitality": {
            "reason": "Erläutern Sie die Gründe Ihrer Bewirtung",
            "merchant": "Restaurant \"Hofbräuhaus\"",
            "attendees": "Schreiben Sie den Namen eines Teilnehmers und drücken Sie die Eingabetaste"
        },
        "folder": {
            "destination": "Vienna",
            "folder_name": "#1 - 01.04.2022 - 12.4.2022 - Vienna"
        },
        "material_code": "Artikel Code"
    },
    "vendor": {
        "company_name": "z.B. Otto, Kaufhof, ...",
        "description": "z.B. Beschreibung des Lieferanten",
        "street_name": "Maxwell Straße",
        "street_number": "31",
        "zip": "80335",
        "city": "München",
        "country": "Deutschland",
        "contact_person_name": "Greta Mustermann",
        "contact_person_email": "greta.mustermann@unternehmen.de",
        "contact_person_phone": "+49 1575 7112363",
        "tax_number": "340291847",
        "vat_number": "BG999999999",
        "bic": "BARCGB22XXX",
        "account_number": "31510604",
        "sort_code": "100000",
        "creditor_number": "70001",
        "select_a_vendor": "Bitte wählen Sie einen Lieferanten"
    },
    "employee": {
        "first_name": "Max",
        "last_name": "Mustermann",
        "email": "max.mustermann@unternehmen.de",
        "location": "München",
        "work_phone": "+49151666666",
        "limit": "Bitte geben Sie ein Limit ein.",
        "position": "Software Entwickler",
        "creditor_number": "95001",
        "mileage_rate": "30 Cent"
    },
    "cost_center": {
        "name": "z.B. Marketing",
        "id": "10",
        "bic": "BARCGB22XXX",
        "budget_value": "200",
        "select_a_cost_center": "Bitte wählen Sie eine Kostenstelle"
    },
    "bug_report_message": "Bitte teilen Sie uns Ihr Feedback oder Ihre Probleme mit.",
    "icon_search": "z.B. Otto, Kaufhof, ...",
    "company_settings": {
        "name": "Finway GmbH",
        "companyIdentifier": "1234",
        "iban": "DE89 3704 0044 0532 0130 00",
        "bic": "BARCGB22XXX",
        "default_creditor_number": "70000",
        "default_employee_creditor_number": "95000",
        "address_line": "Maximilianstraße 14",
        "city": "München",
        "country": "DE",
        "zip": "84052",
        "distance_buffer": "30"
    },
    "banking": {
        "search_term": "BLZ, Bankname oder ähnliches"
    },
    "expense_account": {
        "account_name": "Werbekosten",
        "account_code": "6600",
        "select_an_expense_account": "Bitte wählen Sie ein Sachkonto"
    },
    "cost_center_2": {
        "name": "Produkt A",
        "code": "100",
        "select_a_cost_center_2": "Bitte wählen Sie einen Kostenträger"
    },
    "filter_form": {
        "min_amount": "10",
        "max_amount": "100",
        "min_date": "MM/DD/YYYY",
        "max_date": "MM/DD/YYYY",
        "iban": "DE89 3704 0044 0532 0130 00",
        "min_probability": "0",
        "max_probability": "100",
        "due_in_days": 0
    },
    "expense_filter": {
        "min_amount": "10",
        "max_amount": "100",
        "min_date": "TT.MM.JJJJ",
        "max_date": "TT.MM.JJJJ"
    },
    "inbox_filter": {
        "min_upload_date": "TT.MM.JJJJ",
        "max_upload_date": "TT.MM.JJJJ"
    },
    "matching": {
        "expense_id": "Antrags ID",
        "min_date": "TT.MM.JJJJ",
        "max_date": "TT.MM.JJJJ"
    },
    "export": {
        "date": "TT.MM.JJJJ"
    },
    "search": "Suchbegriff",
    "wallet": {
        "beneficiary_name": "Hans Zimmer",
        "beneficiary_address": "Am Oberwiesenfeld 19, 80809 München",
        "bank_name": "Deutsche Bank",
        "bank_address": "Marienplatz 21, 80331 München",
        "bank_country": "Deutschland",
        "bank_country_code": "DE",
        "verification_code": "Bitte geben Sie den Verifizierungscode ein",
        "description": "Transfer"
    },
    "tax": {
        "tax_rate": "19",
        "bu_code": "9",
        "bu_code_name": "Lieferungen & sonstige Leistungen"
    },
    "team": {
        "team_name": "Finanzen"
    },
    "transaction": {
        "transaction_category": "Kategorie wählen"
    },
    "workflow": {
        "name": "Ihr Workflow Name",
        "request_type": "Bitte wählen Sie aus, welche Antragsart diesen Workflow auslösen soll"
    },
    "start_date": "Startdatum",
    "end_date": "Enddatum",
    "liquidity": {
        "scenario_name": "Szenario-Name",
        "select_a_scenario": "Bitte wählen Sie ein Szenario",
        "transaction_title": "Miete"
    },
    "role_name": "Buchhalter",
    "csv_settings": {
        "new_template_name": "Meine Vorlage"
    },
    "sso": {
        "tenant_domain": "ihre-tenant-domain.de",
        "client_id": "Ihre Client-ID",
        "client_secret": "Ihr Client-Secret"
    },
    "personio": {
        "client_id": "Ihre Client-ID",
        "client_secret": "Ihr Client-Secret",
        "email": "Email eingeben"
    },
    "datev_csv_config": {
        "wallet_account": "3610",
        "cash_transit_account": "1460",
        "account_number_length": "4"
    },
    "datev_client_and_consultant_number": {
        "client_number": "99999",
        "consultant_number": "713111"
    }
}
